import { VirtualBackgroundFailureReason } from 'features/virtual-backgrounds/types';

export type VBGateFailedCondition = 'wasm' | 'webgl' | 'software' | 'unknown';

export class VBGateRefusedError extends Error {
  readonly code = 'vb-gate-refused';

  constructor(readonly failedCondition: VBGateFailedCondition) {
    super(`[VB] capability gate refused (${failedCondition})`);
    this.name = 'VBGateRefusedError';
  }
}

// A teardown signal, not a failure: destroy() landed while the re-probe window was pending.
export class VBGateAbortedError extends Error {
  readonly code = 'vb-gate-aborted';

  constructor() {
    super('[VB] init aborted — provider destroyed during capability re-probe');
    this.name = 'VBGateAbortedError';
  }
}

export const getVirtualBackgroundFailureReason = (
  error: unknown
): VirtualBackgroundFailureReason | null => {
  if (error instanceof VBGateAbortedError) {
    return null;
  }
  return error instanceof VBGateRefusedError ? 'unsupported' : 'failed';
};
